import gettext, { pgettext } from '@sdk/lang/gettext';
import InfoModal from '@sdk/components/ui/InfoModal/InfoModal';

import ExclamationMarkIcon from '@web/assets/svg/UI/exclamation-mark.svg';
import { AnnouncementInnerContent } from '@web/announcements/AnnouncementInnerContent/AnnouncementInnerContent';
import { useGetAnnouncementDetails } from '@web/announcements/hooks/useGetAnnouncementDetails';

import { IconWrapper, Wrapper } from './announcementDetails.styles';

type Props = {
  id: ID;
  onClose: () => void;
  onDelete: (id: ID) => void;
};

export const AnnouncementDetails = ({ id, onClose, onDelete }: Props) => {
  const { data: announcement } = useGetAnnouncementDetails(id);

  const headerTitle = pgettext('Always singular', 'Announcement');

  return (
    <Wrapper>
      <InfoModal
        buttonsPadding={0}
        fullScreen
        titleText={headerTitle}
        titleIcon={
          <IconWrapper>
            <ExclamationMarkIcon aria-hidden={true} />
          </IconWrapper>
        }
        buttonText={gettext('Close')}
        dismiss={onClose}
        zIndex={1045}>
        <AnnouncementInnerContent announcement={announcement} onDelete={onDelete} />
      </InfoModal>
    </Wrapper>
  );
};
